import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, Button, TextField, Checkbox, FormControlLabel, DialogTitle, DialogContent, DialogActions, Dialog, Icon, IconButton } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import AssetUpload from '../asset/AssetUpload';
import * as assetActions from '../asset/store/actions'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // width: '100%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
});

class InstructorQualifications extends Component {
    constructor(props) {
        super(props);
        const instructor_id = this.props.instructor.instructor_id;
        // this.props.getInstructorQualifications(instructor_id)
        this.props.getAllQualifications(this.props.companies.map(c => c.company_id), 'instructor')
        this.state = {
            ...this.state,
            instructor_id: instructor_id,
            dialogActive: false,
            selected_qual_id: 0,
            start: null,
            end: null,
            RequireAsset: 0,
            anchorEl: null,
            menuOpenId: null,
            assetDialogOpen: false,
            assetDialogRow: false
        }
    }
    getDialog = (active) => {

        const assetList = this.props.qualificationAssetList.map((asset, i) => {
            if (!asset) {
                return null
            }
            return (
                <div key={i}>{asset.AssetName}</div>
            )
        })

        const assetUpload = () => {
            if (this.state.RequireAsset === 0) {
                return null
            }
            else {
                return (
                    <div>
                        <AssetUpload
                            file_type={"Instructor Qualification"}
                            auth_id={this.props.instructor.related_auth_id}
                            modelType={"instructor_qualification"}
                            model_id={this.state.selected_qual_id}
                            requires_relation={false}
                            // getAssetList={testFunc}
                            responseFunction={this.props.updateQualificationAsset}
                        />
                        {assetList}
                    </div>
                )
            }
        }

        const qual_ids = this.props.qualificationList.map(q => {
            if (!q.deleted) {
                return q.qualification_id
            }
        });
        const mappedQuals = this.props.allQualifications.filter(q => qual_ids.indexOf(q.qualification_id) === -1)
        // const x = mappedQuals.concat(this.props.qualificationList.filter(qual => qual.deleted))
        const qualItems = mappedQuals.map(q => {
            return (
                <MenuItem key={q.qualification_id} value={q.qualification_id}><b>{q.CompanyName}</b>: <span>{q.QualificationName}</span></MenuItem>
            )
        })
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.handleCloseDialog()}
            >
                <DialogTitle>Apply for Qualification</DialogTitle>
                <DialogContent>
                    <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                        <FormControl variant="outlined">
                            <InputLabel
                                ref={ref => {
                                    this.InputLabelRef = ref;
                                }}
                                htmlFor="outlined-age-simple"
                            >
                                Qualification
                            </InputLabel>
                            <Select
                                style={{ minWidth: '50px' }}
                                value={this.state.selected_qual_id}
                                onChange={
                                    (e) => {
                                        const reqAsset = e.target.value === 0 ? 0 : this.props.allQualifications.filter(q => q.qualification_id === e.target.value)[0].RequireAsset
                                        this.setState
                                            ({
                                                selected_qual_id: e.target.value,
                                                RequireAsset: reqAsset
                                            })

                                    }
                                }
                                input={
                                    <OutlinedInput
                                        labelWidth={90}
                                        name="Qual"
                                        id="outlined-age-simple"
                                    />
                                }
                            >
                                <MenuItem value={0}>
                                    <em>None</em>
                                </MenuItem>
                                {qualItems}
                            </Select>
                        </FormControl>
                    </div>

                    <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                        <TextField
                            variant={'outlined'}
                            id="datetime-local"
                            label="Start Date"
                            type="date"
                            defaultValue={moment().format('mm/dd/YYYY')}
                            className={this.props.classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => this.setState({ start: e.target.value })}
                        />
                    </div>
                    <div style={{ minWidth: '200px', paddingTop: '10px' }}>
                        <TextField
                            variant={'outlined'}
                            id="datetime-local"
                            label="End Date"
                            type="date"
                            defaultValue={moment().format('mm/dd/YYYY')}
                            className={this.props.classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => this.setState({ end: e.target.value })}
                        />
                    </div>
                    <div style={{ minWidth: '300px', paddingTop: '10px' }}>
                        {assetUpload()}
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleApply()} color="primary" variant={'contained'} disabled={this.getApplyButtonDisabled()}>
                        Apply
                </Button>
                    <Button onClick={() => this.handleCloseDialog()} variant="contained">
                        Go Back
                </Button>
                </DialogActions>
            </Dialog>
        )
    }

    getAssetDialog = (open) => {

        const assetList =
            this.props.qualificationAssetList.map(asset => {
                return (
                    <TableRow key={asset.asset_id}>
                        <TableCell>{asset.AssetName}</TableCell>
                    </TableRow>
                )
            })

        return (
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.closeAssetDialog()}
            >
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={4}>
                            <AssetUpload
                                file_type={"Instructor Qualification"}
                                auth_id={this.props.instructor.related_auth_id}
                                modelType={"instructor_qualification"}
                                model_id={this.state.assetDialogRow.instructor_qualification_id}
                                requires_relation={true}
                                // responseFunction={this.props.updateQualificationAsset}
                                getAssetList={this.props.updateQualificationAsset}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <Table>
                                <TableBody>
                                    {assetList}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.closeAssetDialog()} variant="contained">
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    handleOpenMenu = (event, row) => {
        this.setState({ menuOpenId: row.qualification_id, anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.setState({ menuOpenId: null, anchorEl: null })
    }

    closeAssetDialog = () => {
        this.setState({ assetDialogRow: false, assetDialogOpen: false })
        this.props.updateQualificationAsset('clear');
        this.props.getInstructorQualifications(this.state.instructor_id)
    }

    getApplyButtonDisabled = () => {
        if (this.state.selected_qual_id === 0) {
            return true
        }
        else if (this.state.RequireAsset === 1 && this.props.qualificationAssetList.length === 0) {
            return true
        }
        return false
    }

    handleCloseDialog = () => {
        if (this.props.qual_asset) {
            this.props.deleteAsset(this.props.qual_asset.asset_id)
        }

        this.props.updateQualificationAsset('clear')
        this.setState({ dialogActive: false, selected_qual_id: 0, start: null, end: null, RequireAsset: 0 })
    }

    handleApply = () => {
        const qual = this.props.allQualifications.filter(q => q.qualification_id === this.state.selected_qual_id)[0]
        this.props.adminAddQualification(qual, this.state.instructor_id, this.state.start, this.state.end, this.props.qualificationAssetList)
        this.props.updateQualificationAsset('clear')
        this.setState({ dialogActive: false, selected_qual_id: 0, start: null, end: null, RequireAsset: 0 })
    }

    handleAssetDialogOpen = (row) => {
        this.props.updateQualificationAsset(row.assetList)
        this.setState({
            assetDialogOpen: true,
            assetDialogRow: row
        })
    }

    render() {
        const { classes } = this.props;
        const { anchorEl, menuOpenId } = this.state;
        const dateCell = (qual, date, column) => {

            let defaultDate = date ? moment(date).format('YYYY-MM-DD') : null
            return (
                <TextField
                    variant='outlined'
                    id="datetime-local"
                    label=""
                    type="date"
                    defaultValue={defaultDate}
                    className={this.props.classes.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={this.props.view_type === 'detail'}
                    onChange={(e) => this.props.handleRowUpdate(qual, e.target.value, column)}
                />
            )

        }

        const pendingCell = (qual) => {
            if (this.props.view_type === 'detail') {
                return null
            }
            if (qual.Approved === 0) {
                return (
                    <div>
                        <IconButton
                            onClick={() => this.props.acceptQualification(qual)}
                        >
                            <Icon>check_circle</Icon>
                        </IconButton>
                        <IconButton
                            onClick={() => this.props.deleteQualification(qual, this.props.instructor.instructor_id)}
                        >
                            <Icon>delete</Icon>
                        </IconButton>
                    </div>
                )
            }
            return (
                <div>
                    <IconButton
                        onClick={() => this.props.deleteQualification(qual, this.props.instructor.instructor_id)}
                    >
                        <Icon>delete</Icon>
                    </IconButton>
                </div>
            )
        }

        const documentCell = (row) => {

            const addIcon = (
                <IconButton
                    onClick={() => this.handleAssetDialogOpen(row)}
                >
                    <Icon>add</Icon>
                </IconButton>
            )

            const menuItems = row.assetList.map(asset => {
                return (
                    <MenuItem key={asset.asset_id} onClick={this.handleClose}>
                        <a href={asset.URL} target="_blank"><Icon>cloud_download</Icon>{asset.AssetName}</a>
                    </MenuItem>
                )
            })

            const menu = (
                <React.Fragment>
                    <IconButton
                        aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        onClick={(e) => this.handleOpenMenu(e, row)}
                    >
                        <Icon>cloud_download</Icon>
                    </IconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        open={row.qualification_id === menuOpenId}
                        onClose={this.handleClose}
                    >
                        {menuItems}
                    </Menu>
                </React.Fragment>
            )

            if (row.IsAsset === 0) {
                return null
            }

            if (this.props.view_type === 'edit') {
                if (row.assetList.length === 0) {
                    return addIcon
                }
                else {
                    return (
                        <div>
                            {menu}
                            {addIcon}
                        </div>
                    )
                }
            }
            else {
                if (row.assetList.length === 0) {
                    return null
                }
                else {
                    return (
                        menu
                    )
                }
            }

        }

        const statusCell = (row) => {
            if (row.Approved === 0) {
                return <div>Awaiting Action</div>
            }
            return <div>Approved</div>
        }
        
        const qualSelections = this.props.companies.map(company => {
            const companyQuals = this.props.qualificationList.filter(q => q.company_id === company.company_id && !q.deleted);
            const heading = <h2>{company.CompanyName}</h2>;
            const itemSelect = companyQuals.map(qual => {
                return (
                    <TableRow key={qual.qualification_id}>
                        <TableCell>
                            {qual.QualificationName}
                        </TableCell>
                        <TableCell padding={'none'}>{dateCell(qual, qual.StartDate, 'StartDate')}</TableCell>
                        <TableCell padding={'none'}>{dateCell(qual, qual.EndDate, 'EndDate')}</TableCell>
                        <TableCell padding={'none'}>{statusCell(qual)}</TableCell>
                        <TableCell padding={'none'}>{pendingCell(qual)}</TableCell>
                        <TableCell padding={'none'}>{documentCell(qual)}</TableCell>
                    </TableRow>
                )
            })
            return (
                <div key={company.company_id}>
                    {heading}
                    <Table className={classes.table} style={{ marginBottom: '20px' }}>
                        <colgroup>
                            <col style={{ width: '25%' }}></col>
                            <col style={{ width: '20%' }}></col>
                            <col style={{ width: '20%' }}></col>
                            <col style={{ width: '15%' }}></col>
                            <col style={{ width: '10%' }}></col>
                            <col style={{ width: '10%' }}></col>
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell padding={'none'}>Qualification</TableCell>
                                <TableCell padding={'none'}>Start Date</TableCell>
                                <TableCell padding={'none'}>End Date</TableCell>
                                <TableCell padding={'none'}>Status</TableCell>
                                <TableCell padding={'none'}></TableCell>
                                <TableCell padding={'none'}>Document</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {itemSelect}
                        </TableBody>
                    </Table>
                </div>
            )
        })

        const applyButton = (
            this.props.allQualifications.length > 0 ?
                <Button
                    color={'primary'}
                    variant={'contained'}
                    onClick={() => this.setState({ dialogActive: true })}
                >
                    Apply
                </Button>
                :
                null
        )

        const dialog = this.getDialog(this.state.dialogActive)
        const assetDialog = this.getAssetDialog(this.state.assetDialogOpen)

        return (
            <div className="p-24">
                {this.props.view_type === 'edit' ? applyButton : null}
                {assetDialog}
                {dialog}
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        {this.props.companies.length === 0 ? <div> This Instructor is not affiliated with any companies </div> : null}
                        {qualSelections}
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        handleQualificationSelect: Actions.handleQualificationSelect,
        handleRowUpdate: Actions.handleQualificationTimeChange,
        deleteQualification: Actions.deleteQualification,
        acceptQualification: Actions.acceptQualification,
        getInstructorQualifications: Actions.getInstructorQualifications,
        getAllQualifications: Actions.getAllQualifications,
        adminAddQualification: Actions.adminAddQualification,
        updateQualificationAsset: Actions.updateQualificationAsset,
        deleteAsset: assetActions.deleteAsset,
        addAssetToList: Actions.addAssetToList
    }, dispatch);
}

function mapStateToProps({ instructorApp, validator, auth }) {
    return {
        auth,
        qualificationList: instructorApp.instructors.qualifications,
        allQualifications: instructorApp.instructors.allQualifications,
        qual_asset: instructorApp.instructors.qual_asset,
        qualificationAssetList: instructorApp.instructors.qualificationAssetList,
        addAssetToList: Actions.addAssetToList
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorQualifications)));


// WEBPACK FOOTER //
// src/main/content/instructor/InstructorQualificiations.js